(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDeleteController',RuoloDeleteController);

    RuoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ruolo'];

    function RuoloDeleteController($uibModalInstance, entity, Ruolo) {
        var vm = this;

        vm.ruolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ruolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
